const Api =  {
  // VirtualGroups: '/merchant/store/virtual-item-groups',
  VirtualGroups: '/api/v2/merchant/virtual-group/get',
  StoreVirtualGroups: '/api/v2/store/virtual-group/get',
  ViewSourceList: '/api/v2/merchant/bi/store/view-source-pairs'
}

export default (request) => {
  return {
    getVirtualGroups: (params, options) => {
      return request.get(options.editing ? Api.VirtualGroups : Api.StoreVirtualGroups, { params, ...options })
    }
  }
}
